import React, { useState, useEffect, useRef } from 'react';
import Login from './components/Login';
import ChatInterface from './components/ChatInterface';
import PopupChatbot from './components/PopupChatbot';
import ConversationSidebar from './components/ConversationSidebar';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [token, setToken] = useState(null);
  const [userId, setUserId] = useState('');
  const [casinoId, setCasinoId] = useState('');
  const [mode, setMode] = useState('standalone');

  // Day 6 — conversation state
  const [activeConversationId, setActiveConversationId] = useState(null);
  const [sidebarRefreshKey, setSidebarRefreshKey] = useState(0);
  const chatRef = useRef(null);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('mode') === 'popup' || process.env.REACT_APP_BUILD_MODE === 'widget') {
      setMode('popup');
    }

    const savedToken = localStorage.getItem('casino_token');
    const savedUserId = localStorage.getItem('user_id');
    const savedCasinoId = localStorage.getItem('casino_id');

    if (savedToken && savedUserId && savedCasinoId) {
      // Check token expiry before restoring session
      try {
        const payload = JSON.parse(atob(savedToken.split('.')[1]));
        if (payload.exp * 1000 > Date.now()) {
          setToken(savedToken);
          setUserId(savedUserId);
          setCasinoId(savedCasinoId);
          setIsAuthenticated(true);
        } else {
          // Token expired — clear storage
          localStorage.removeItem('casino_token');
          localStorage.removeItem('user_id');
          localStorage.removeItem('casino_id');
        }
      } catch (e) {
        localStorage.removeItem('casino_token');
        localStorage.removeItem('user_id');
        localStorage.removeItem('casino_id');
      }
    }
  }, []);

  const handleLogin = (accessToken, user, casino) => {
    setToken(accessToken);
    setUserId(user);
    setCasinoId(casino);
    setIsAuthenticated(true);
    localStorage.setItem('casino_token', accessToken);
    localStorage.setItem('user_id', user);
    localStorage.setItem('casino_id', casino);
  };

  const handleLogout = () => {
    setToken(null);
    setUserId('');
    setCasinoId('');
    setIsAuthenticated(false);
    setActiveConversationId(null);
    localStorage.removeItem('casino_token');
    localStorage.removeItem('user_id');
    localStorage.removeItem('casino_id');
  };

  // Called when user clicks a conversation in sidebar
  const handleConversationSelect = (conversationId) => {
    setActiveConversationId(conversationId);
    if (chatRef.current) {
      chatRef.current.loadConversation(conversationId);
    }
  };

  // Called when user clicks New Chat
  const handleNewChat = () => {
    setActiveConversationId(null);
    if (chatRef.current) {
      chatRef.current.clearMessages();
    }
  };

  // Called after first message is sent and backend creates conversation
  const handleConversationCreated = (conversationId) => {
    setActiveConversationId(conversationId);
    setSidebarRefreshKey(prev => prev + 1);
  };

  if (mode === 'popup') {
    return <PopupChatbot />;
  }

  return (
    <div style={{
      width: '100%',
      height: '100%',
      margin: 0,
      padding: 0,
      background: '#2f2f2f',
      overflow: 'hidden',
    }}>
      {!isAuthenticated ? (
        <Login onLogin={handleLogin} />
      ) : (
        <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>

          {/* Sidebar — left panel */}
          <ConversationSidebar
            key={sidebarRefreshKey}
            token={token}
            currentConversationId={activeConversationId}
            onConversationSelect={handleConversationSelect}
            onNewChat={handleNewChat}
            onLogout={handleLogout}
            casinoId={casinoId}
          />

          {/* Chat — fills remaining space */}
          <div style={{ flex: 1, overflow: 'hidden', minWidth: 0 }}>
            <ChatInterface
              ref={chatRef}
              token={token}
              userId={userId}
              casinoId={casinoId}
              onLogout={handleLogout}
              activeConversationId={activeConversationId}
              onConversationCreated={handleConversationCreated}
            />
          </div>

        </div>
      )}
    </div>
  );
}

export default App;